import React, { Component } from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button, Form, FormGroup, Label, Input, FormText } from 'reactstrap';
import Types from "constants/Types";
import ObjectOverride from "components/ObjectOverride";
import API from "@beardeddevops/react.api";
import Framework from "@beardeddevops/react.framework";

const CATEGORY_NAME_TO_ID = {
	"Collectible Firearms": 0,
	"Black Powder / Muzzleloaders": 1,
	"Everything Else": 2,
	"Other Pistols": 3,
	"Semi Auto Pistols": 4,
	"Revolvers": 5,
	"Single Shot Pistols": 6,
	"Pump Action Rifles": 7,
	"Single Shot Rifles": 8,
	"Semi Auto Rifles": 9,
	"Bolt Action Rifles": 10,
	"Lever Action Rifles": 11,
	"Other Rifles": 12,
	"Pump Action Shotguns": 13,
	"Semi Auto Shotguns": 14,
	"Side-by-Side Shotguns": 15,
	"Other Shotguns": 16,
	"Single Shot Shotguns": 17,
	"Over/Under Shotguns": 18,
	"Ammunition": 19,
	"Accessories": 20,
	"Magazines": 21,
	"Suppressor": 22,
	"NFA": 23,
	"Optics": 24,
};

class InventoryModal extends ObjectOverride {

	constructor(props) {
		super(props, Types.Products._name);
		this.state = {
			AddToGA: true,
			ListingType: 0,
			Caliber: '',
			CategoryID: '',
			Description: '',
			Condition: '',
			FixedPrice: 0,
			Manufacturer: '',
			MfgPartNumber: '',
			Model: '',
			PictureURLs: '',
			Quantity: '',
			SerialNumber: '',
			ShippingCost: '',
			ShippingText: '',
			Title: '',
			UPC: '',
			Weight: '',
			WeightUnit: 0
		};

	}

	componentDidUpdate(prevProps, prevState, snapshot) {
		const updatedProduct = this.props.updatedProduct;
		const prevUpdatedProduct = prevProps.updatedProduct;

		const hasUpdatedProduct =
			updatedProduct && Object.keys(updatedProduct).length > 0;

		if (hasUpdatedProduct && updatedProduct !== prevUpdatedProduct) {

			const categoryName = updatedProduct.categoryName;

			this.setState({
				Condition: updatedProduct.condition,
				Caliber: updatedProduct.caliber,
				CategoryID: CATEGORY_NAME_TO_ID[categoryName] ?? "",
				AddToGA: updatedProduct.addToGA,
				UPC: updatedProduct.upc,
				PictureURLs: updatedProduct.pictureURLs,
				Quantity: updatedProduct.quantity,
				Title: updatedProduct.title,
				SerialNumber: updatedProduct.serialNumber,
				FixedPrice: String(updatedProduct.fixedPrice ?? ""),
				ListingType: updatedProduct.listingType,
				Manufacturer: updatedProduct.manufacturer,
				Model: updatedProduct.model,
				Description: updatedProduct.description,
				ShippingCost: updatedProduct.shippingCost,
				ShippingText: updatedProduct.shippingText,
				Weight: updatedProduct.weight,
			});
		}
		else if (
			(!updatedProduct || Object.keys(updatedProduct).length === 0) &&
			this.props.product &&
			this.props.product !== prevProps.product
		) {

			let condition = this.props.product.used === "" ? 0 : 1;

			this.setState({
				UPC: this.props.product.upc,
				SerialNumber: this.props.product.serial_number,
				Condition: condition,
				FixedPrice: String(this.props.product.price_list ?? ""),
				Manufacturer: this.props.product.manufacturers
					? this.props.product.manufacturers.name
					: this.props.product.manufacturer_other,
				Model: this.props.product.model,
				Caliber: this.props.product.calibers
					? this.props.product.calibers.name
					: this.props.product.caliber_other,
				Quantity: 1,
			});
		}

	}

	handleInputChange = (e) => {
		const { name, value, type, checked } = e.target;
		this.setState({
			[name]: type === 'checkbox' ? checked : value
		});
	};

	/**
	 *
	 * @param e
	 * @returns {Promise<void>}
	 */
	handleSubmit = async (e) => {
		e.preventDefault();
		this.setState({ loading: true });

		try {
			let gaModel = new API.BuildClass(Types.Products._name, 'POST_GUNSAMERICA_PRODUCT');

			gaModel.object.gunsamerica_product = JSON.stringify(this.state);
			gaModel.object.acq_id = this.props.product._id;

			let result = await gaModel.submit(null, 'POST_GUNSAMERICA_PRODUCT');

			if (result && result.listingUrl) {
				await new Promise(r => setTimeout(r, 1000));
				window.open(result.listingUrl, '_blank');
				this.props.toggle();
			}
		} catch (err) {
			console.error('GA submit failed:', err);
		} finally {
			this.setState({ loading: false });
		}
	};


	render() {
		const { isOpen, toggle } = this.props;
		return (
			<Modal isOpen={isOpen} toggle={toggle} size="lg">
				<ModalHeader toggle={toggle}>Add/Update Inventory Item</ModalHeader>
				<Form onSubmit={this.handleSubmit}>
					<ModalBody>
						<FormGroup check className="mb-3">
							<Label check>
								<Input
									type="checkbox"
									name="AddToGA"
									checked={this.state.AddToGA}
									onChange={this.handleInputChange}
								/>
								{' '}List item on GA Listings
							</Label>
						</FormGroup>

						<FormGroup>
							<Label for="ListingType">Listing Type</Label>
							<Input
								type="select"
								name="ListingType"
								id="ListingType"
								value={this.state.ListingType}
								onChange={this.handleInputChange}
							>
								<option value={0}>National</option>
								<option value={2}>Local</option>
							</Input>
						</FormGroup>

						<FormGroup>
							<Label for="UPC">UPC</Label>
							<Input
								type="text"
								name="UPC"
								id="UPC"
								value={this.state.UPC}
								onChange={this.handleInputChange}
								placeholder="Item UPC if available"
							/>
							<FormText color="muted">
								If UPC is provided, many fields below become optional
							</FormText>
						</FormGroup>

						<FormGroup>
							<Label for="Condition">Condition *</Label>
							<Input
								type="select"
								name="Condition"
								id="Condition"
								value={this.state.Condition}
								onChange={this.handleInputChange}
								required
							>
								<option value="">Select condition...</option>
								<option value={0}>New in Box</option>
								<option value={1}>Used</option>
								<option value={2}>Never Fired</option>
							</Input>
						</FormGroup>

						<FormGroup>
							<Label for="FixedPrice">Price *</Label>
							<Input
								type="number"
								step="0.01"
								name="FixedPrice"
								id="FixedPrice"
								value={this.state.FixedPrice}
								onChange={this.handleInputChange}
								placeholder="Item price"
								required
							/>
						</FormGroup>

						<FormGroup>
							<Label for="Quantity">Quantity *</Label>
							<Input
								type="number"
								name="Quantity"
								id="Quantity"
								value={this.state.Quantity}
								onChange={this.handleInputChange}
								placeholder="Quantity"
								required
							/>
						</FormGroup>

						<FormGroup>
							<Label for="SerialNumber">Seller Stock Number *</Label>
							<Input
								type="text"
								name="SerialNumber"
								id="SerialNumber"
								value={this.state.SerialNumber}
								onChange={this.handleInputChange}
								placeholder="Your internal stock number"
								required
							/>
							<FormText color="muted">
								Used to identify and manage this item
							</FormText>
						</FormGroup>

						<hr />
						<h6>Required if UPC is not provided</h6>

						<FormGroup>
							<Label for="Manufacturer">Manufacturer</Label>
							<Input
								type="text"
								name="Manufacturer"
								id="Manufacturer"
								value={this.state.Manufacturer}
								onChange={this.handleInputChange}
								placeholder="Name of manufacturer"
								required={!this.state.UPC}
							/>
						</FormGroup>

						<FormGroup>
							<Label for="Model">Model</Label>
							<Input
								type="text"
								name="Model"
								id="Model"
								value={this.state.Model}
								onChange={this.handleInputChange}
								placeholder="Name of model"
								required={!this.state.UPC}
							/>
						</FormGroup>

						<FormGroup>
							<Label for="CategoryID">Category</Label>
							<Input
								type="select"
								name="CategoryID"
								id="CategoryID"
								value={this.state.CategoryID}
								onChange={this.handleInputChange}
								required={!this.state.UPC}
							>
								<option value="">Select a category</option>
								<option value={0}>Collectible Firearms</option>
								<option value={1}>Black Powder / Muzzleloaders</option>
								<option value={2}>Everything Else</option>
								<option value={3}>Other Pistols</option>
								<option value={4}>Semi Auto Pistols</option>
								<option value={5}>Revolvers</option>
								<option value={6}>Single Shot Pistols</option>
								<option value={7}>Pump Action Rifles</option>
								<option value={8}>Single Shot Rifles</option>
								<option value={9}>Semi Auto Rifles</option>
								<option value={10}>Bolt Action Rifles</option>
								<option value={11}>Lever Action Rifles</option>
								<option value={12}>Other Rifles</option>
								<option value={13}>Pump Action Shotguns</option>
								<option value={14}>Semi Auto Shotguns</option>
								<option value={15}>Side-by-Side Shotguns</option>
								<option value={16}>Other Shotguns</option>
								<option value={17}>Single Shot Shotguns</option>
								<option value={18}>Over/Under Shotguns</option>
								<option value={19}>Ammunition</option>
								<option value={20}>Accessories</option>
								<option value={21}>Magazines</option>
								<option value={22}>Suppressor</option>
								<option value={23}>NFA</option>
								<option value={24}>Optics</option>
							</Input>
						</FormGroup>


						<FormGroup>
							<Label for="Caliber">Caliber</Label>
							<Input
								type="text"
								name="Caliber"
								id="Caliber"
								value={this.state.Caliber}
								onChange={this.handleInputChange}
								placeholder="Caliber that item uses"
								required={!this.state.UPC}
							/>
						</FormGroup>

						<FormGroup>
							<Label for="Title">Item Title</Label>
							<Input
								type="text"
								name="Title"
								id="Title"
								value={this.state.Title}
								onChange={this.handleInputChange}
								placeholder="Item title"
								required={!this.state.UPC}
							/>
						</FormGroup>

						<FormGroup>
							<Label for="PictureURLs">Picture URLs</Label>
							<Input
								type="textarea"
								name="PictureURLs"
								id="PictureURLs"
								value={this.state.PictureURLs}
								onChange={this.handleInputChange}
								placeholder="Comma delimited image URLs"
								required={!this.state.UPC}
							/>
							<FormText color="muted">
								Separate multiple URLs with commas
							</FormText>
						</FormGroup>

						<hr />
						<h6>Optional Fields</h6>

						<FormGroup>
							<Label for="Description">Description</Label>
							<Input
								type="textarea"
								name="Description"
								id="Description"
								value={this.state.Description}
								onChange={this.handleInputChange}
								placeholder="Item description (max 5000 characters)"
								rows="4"
							/>
							<FormText color="muted">
								Non-ASCII characters will be removed
							</FormText>
						</FormGroup>

						<FormGroup>
							<Label for="MfgPartNumber">Manufacturer Part Number</Label>
							<Input
								type="text"
								name="MfgPartNumber"
								id="MfgPartNumber"
								value={this.state.MfgPartNumber}
								onChange={this.handleInputChange}
								placeholder="Item part number"
							/>
						</FormGroup>

						<FormGroup>
							<Label for="ShippingCost">Shipping Cost</Label>
							<Input
								type="number"
								step="0.01"
								name="ShippingCost"
								id="ShippingCost"
								value={this.state.ShippingCost}
								onChange={this.handleInputChange}
								placeholder="Shipping cost (defaults to free if not entered)"
							/>
						</FormGroup>

						<FormGroup>
							<Label for="ShippingText">Shipping Text</Label>
							<Input
								type="textarea"
								name="ShippingText"
								id="ShippingText"
								value={this.state.ShippingText}
								onChange={this.handleInputChange}
								placeholder="Shipping text (max 500 characters)"
								rows="2"
							/>
							<FormText color="muted">
								Non-ASCII characters will be removed
							</FormText>
						</FormGroup>

						<FormGroup>
							<Label for="Weight">Weight* (in pounds)</Label>
							<Input
								type="number"
								step="0.01"
								min="0.01"
								name="Weight"
								id="Weight"
								value={this.state.Weight}
								onChange={this.handleInputChange}
								placeholder="Item weight"
								required
							/>
						</FormGroup>


					</ModalBody>

					<ModalFooter>
						<Button color="primary" type="submit">
							Submit
						</Button>
						{' '}
						<Button color="secondary" onClick={toggle}>
							Cancel
						</Button>
					</ModalFooter>
				</Form>
				<Framework.Elements.LoadingSpinner isLoading={this.state.loading}/>

			</Modal>

		);
	}
}

export default InventoryModal;